import Phaser from 'phaser';
import { SCENE_KEYS, SCENE_LIST } from '@/engine/nav';

/**
 * Punto de entrada. Configuración del juego: orientación vertical (portrait)
 * 720×1280, escalado FIT + CENTER_BOTH para encajar en cualquier móvil sin
 * deformar, fondo oscuro, y touch como input primario (el ratón funciona
 * igual gracias al sistema de input unificado de Phaser).
 */
const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'app',
  backgroundColor: '#0b0b10',
  width: 720,
  height: 1280,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: 720,
    height: 1280,
  },
  input: {
    activePointers: 2, // deja sitio a un segundo dedo sin activar gestos complejos
  },
  scene: SCENE_LIST,
};

new Phaser.Game(config);

// Referencia disponible por si algún bloque futuro necesita la clave de la
// escena de arranque desde fuera (debug, tests manuales).
void SCENE_KEYS.BOOT;
